import * as React from 'react';

import * as styles from './HintQuestionsLayout.css';

interface IHintQuestionsLayoutProps {
  children: React.ReactNode;
}

export const HintQuestionsLayout: React.FC<IHintQuestionsLayoutProps> = ({ children }) => {
  return <div className={styles['container']}>{children}</div>;
};
